"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: tier/tier-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftier%2Ftier-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierServiceClient = exports.UpdateSubscriptionPaymentResponse = exports.UpdateSubscriptionPaymentRequest = exports.TryLookupSubscriptionResponse = exports.TryLookupSubscriptionRequest = exports.CancelSubscriptionResponse = exports.CancelSubscriptionRequest = exports.ResubscribeResponse = exports.ResubscribeRequest = exports.SubscribeResponse = exports.SubscribeRequest = exports.GetTierCatalogResponseTierProduct = exports.GetTierCatalogResponse = exports.GetTierCatalogRequest = exports.GetTiersResponse = exports.GetTiersRequest = exports.GetUserTierResponse = exports.GetUserTierRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const product_variant_1 = require("../common/product-variant");
const qualifying_event_1 = require("../common/qualifying-event");
const cancellation_reason_1 = require("./cancellation-reason");
const tier_1 = require("./tier");
const tier_type_1 = require("./tier-type");
const protobufPackage = 'com.step.tier.proto';
function createBaseGetUserTierRequest() {
    return { currency: '' };
}
exports.GetUserTierRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.currency)) {
            message.currency = globalThis.String(object.currency);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.currency !== undefined && message.currency !== '') {
            obj.currency = message.currency;
        }
        return obj;
    },
    create(base) {
        return exports.GetUserTierRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUserTierRequest();
        message.currency = object.currency ?? '';
        return message;
    },
};
function createBaseGetUserTierResponse() {
    return {
        tier: tier_1.Tier.fromPartial({}),
        typeChanged: undefined,
        expiresAtMs: '0',
        qualifyingEvent: qualifying_event_1.QualifyingEvent.INVALID_QUALIFYING_EVENT,
    };
}
exports.GetUserTierResponse = {
    fromJSON(object) {
        const message = {
            tier: isSet(object.tier) ? tier_1.Tier.fromJSON(object.tier) : tier_1.Tier.fromPartial({}),
        };
        if (isSet(object.typeChanged)) {
            message.typeChanged = tier_1.TypeChanged.fromJSON(object.typeChanged);
        }
        if (isSet(object.expiresAtMs)) {
            message.expiresAtMs = globalThis.String(object.expiresAtMs);
        }
        if (isSet(object.qualifyingEvent)) {
            message.qualifyingEvent = (0, qualifying_event_1.qualifyingEventFromJSON)(object.qualifyingEvent);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.tier !== undefined) {
            obj.tier = tier_1.Tier.toJSON(message.tier);
        }
        if (message.typeChanged !== undefined) {
            obj.typeChanged = tier_1.TypeChanged.toJSON(message.typeChanged);
        }
        if (message.expiresAtMs !== undefined && message.expiresAtMs !== '0') {
            obj.expiresAtMs = message.expiresAtMs;
        }
        if (message.qualifyingEvent !== undefined &&
            message.qualifyingEvent !== qualifying_event_1.QualifyingEvent.INVALID_QUALIFYING_EVENT) {
            obj.qualifyingEvent = (0, qualifying_event_1.qualifyingEventToJSON)(message.qualifyingEvent);
        }
        return obj;
    },
    create(base) {
        return exports.GetUserTierResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUserTierResponse();
        message.tier = (object.tier !== undefined && object.tier !== null)
            ? tier_1.Tier.fromPartial(object.tier)
            : tier_1.Tier.fromPartial({});
        message.typeChanged = (object.typeChanged !== undefined && object.typeChanged !== null)
            ? tier_1.TypeChanged.fromPartial(object.typeChanged)
            : undefined;
        message.expiresAtMs = object.expiresAtMs ?? '0';
        message.qualifyingEvent = object.qualifyingEvent ?? qualifying_event_1.QualifyingEvent.INVALID_QUALIFYING_EVENT;
        return message;
    },
};
function createBaseGetTiersRequest() {
    return { currency: '', productVariant: product_variant_1.ProductVariant.INVALID_PRODUCT_VARIANT };
}
exports.GetTiersRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.currency)) {
            message.currency = globalThis.String(object.currency);
        }
        if (isSet(object.productVariant)) {
            message.productVariant = (0, product_variant_1.productVariantFromJSON)(object.productVariant);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.currency !== undefined && message.currency !== '') {
            obj.currency = message.currency;
        }
        if (message.productVariant !== undefined &&
            message.productVariant !== product_variant_1.ProductVariant.INVALID_PRODUCT_VARIANT) {
            obj.productVariant = (0, product_variant_1.productVariantToJSON)(message.productVariant);
        }
        return obj;
    },
    create(base) {
        return exports.GetTiersRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTiersRequest();
        message.currency = object.currency ?? '';
        message.productVariant = object.productVariant ?? product_variant_1.ProductVariant.INVALID_PRODUCT_VARIANT;
        return message;
    },
};
function createBaseGetTiersResponse() {
    return { tier: [] };
}
exports.GetTiersResponse = {
    fromJSON(object) {
        const message = {
            tier: globalThis.Array.isArray(object?.tier)
                ? object.tier.map((e) => tier_1.Tier.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.tier?.length) {
            obj.tier = message.tier.map((e) => tier_1.Tier.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetTiersResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTiersResponse();
        message.tier = object.tier?.map((e) => tier_1.Tier.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetTierCatalogRequest() {
    return { currency: '', productVariant: product_variant_1.ProductVariant.INVALID_PRODUCT_VARIANT };
}
exports.GetTierCatalogRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.currency)) {
            message.currency = globalThis.String(object.currency);
        }
        if (isSet(object.productVariant)) {
            message.productVariant = (0, product_variant_1.productVariantFromJSON)(object.productVariant);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.currency !== undefined && message.currency !== '') {
            obj.currency = message.currency;
        }
        if (message.productVariant !== undefined &&
            message.productVariant !== product_variant_1.ProductVariant.INVALID_PRODUCT_VARIANT) {
            obj.productVariant = (0, product_variant_1.productVariantToJSON)(message.productVariant);
        }
        return obj;
    },
    create(base) {
        return exports.GetTierCatalogRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTierCatalogRequest();
        message.currency = object.currency ?? '';
        message.productVariant = object.productVariant ?? product_variant_1.ProductVariant.INVALID_PRODUCT_VARIANT;
        return message;
    },
};
function createBaseGetTierCatalogResponse() {
    return { tiers: [] };
}
exports.GetTierCatalogResponse = {
    fromJSON(object) {
        const message = {
            tiers: globalThis.Array.isArray(object?.tiers)
                ? object.tiers.map((e) => exports.GetTierCatalogResponseTierProduct.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.tiers?.length) {
            obj.tiers = message.tiers.map((e) => exports.GetTierCatalogResponseTierProduct.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetTierCatalogResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTierCatalogResponse();
        message.tiers = object.tiers?.map((e) => exports.GetTierCatalogResponseTierProduct.fromPartial(e)) ||
            [];
        return message;
    },
};
function createBaseGetTierCatalogResponseTierProduct() {
    return { type: tier_type_1.TierType.INVALID_TIER, subscription: undefined, offers: [] };
}
exports.GetTierCatalogResponseTierProduct = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type) ? (0, tier_type_1.tierTypeFromJSON)(object.type) : tier_type_1.TierType.INVALID_TIER,
        };
        if (isSet(object.subscription)) {
            message.subscription = tier_1.Subscription.fromJSON(object.subscription);
        }
        if (globalThis.Array.isArray(object?.offers)) {
            message.offers = object.offers.map((e) => tier_1.TierOffer.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== tier_type_1.TierType.INVALID_TIER) {
            obj.type = (0, tier_type_1.tierTypeToJSON)(message.type);
        }
        if (message.subscription !== undefined) {
            obj.subscription = tier_1.Subscription.toJSON(message.subscription);
        }
        if (message.offers?.length) {
            obj.offers = message.offers.map((e) => tier_1.TierOffer.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetTierCatalogResponseTierProduct.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTierCatalogResponseTierProduct();
        message.type = object.type ?? tier_type_1.TierType.INVALID_TIER;
        message.subscription = (object.subscription !== undefined && object.subscription !== null)
            ? tier_1.Subscription.fromPartial(object.subscription)
            : undefined;
        message.offers = object.offers?.map((e) => tier_1.TierOffer.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSubscribeRequest() {
    return {
        tierType: tier_type_1.TierType.INVALID_TIER,
        productVariant: product_variant_1.ProductVariant.INVALID_PRODUCT_VARIANT,
        externalAccountId: '',
    };
}
exports.SubscribeRequest = {
    fromJSON(object) {
        const message = {
            tierType: isSet(object.tierType) ? (0, tier_type_1.tierTypeFromJSON)(object.tierType) : tier_type_1.TierType.INVALID_TIER,
        };
        if (isSet(object.productVariant)) {
            message.productVariant = (0, product_variant_1.productVariantFromJSON)(object.productVariant);
        }
        if (isSet(object.externalAccountId)) {
            message.externalAccountId = globalThis.String(object.externalAccountId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.tierType !== tier_type_1.TierType.INVALID_TIER) {
            obj.tierType = (0, tier_type_1.tierTypeToJSON)(message.tierType);
        }
        if (message.productVariant !== undefined &&
            message.productVariant !== product_variant_1.ProductVariant.INVALID_PRODUCT_VARIANT) {
            obj.productVariant = (0, product_variant_1.productVariantToJSON)(message.productVariant);
        }
        if (message.externalAccountId !== undefined && message.externalAccountId !== '') {
            obj.externalAccountId = message.externalAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.SubscribeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscribeRequest();
        message.tierType = object.tierType ?? tier_type_1.TierType.INVALID_TIER;
        message.productVariant = object.productVariant ?? product_variant_1.ProductVariant.INVALID_PRODUCT_VARIANT;
        message.externalAccountId = object.externalAccountId ?? '';
        return message;
    },
};
function createBaseSubscribeResponse() {
    return { subscription: tier_1.TierSubscription.fromPartial({}) };
}
exports.SubscribeResponse = {
    fromJSON(object) {
        const message = {
            subscription: isSet(object.subscription)
                ? tier_1.TierSubscription.fromJSON(object.subscription)
                : tier_1.TierSubscription.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.subscription !== undefined) {
            obj.subscription = tier_1.TierSubscription.toJSON(message.subscription);
        }
        return obj;
    },
    create(base) {
        return exports.SubscribeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscribeResponse();
        message.subscription = (object.subscription !== undefined && object.subscription !== null)
            ? tier_1.TierSubscription.fromPartial(object.subscription)
            : tier_1.TierSubscription.fromPartial({});
        return message;
    },
};
function createBaseResubscribeRequest() {
    return { tierType: tier_type_1.TierType.INVALID_TIER };
}
exports.ResubscribeRequest = {
    fromJSON(object) {
        const message = {
            tierType: isSet(object.tierType) ? (0, tier_type_1.tierTypeFromJSON)(object.tierType) : tier_type_1.TierType.INVALID_TIER,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.tierType !== tier_type_1.TierType.INVALID_TIER) {
            obj.tierType = (0, tier_type_1.tierTypeToJSON)(message.tierType);
        }
        return obj;
    },
    create(base) {
        return exports.ResubscribeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseResubscribeRequest();
        message.tierType = object.tierType ?? tier_type_1.TierType.INVALID_TIER;
        return message;
    },
};
function createBaseResubscribeResponse() {
    return { subscription: tier_1.TierSubscription.fromPartial({}) };
}
exports.ResubscribeResponse = {
    fromJSON(object) {
        const message = {
            subscription: isSet(object.subscription)
                ? tier_1.TierSubscription.fromJSON(object.subscription)
                : tier_1.TierSubscription.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.subscription !== undefined) {
            obj.subscription = tier_1.TierSubscription.toJSON(message.subscription);
        }
        return obj;
    },
    create(base) {
        return exports.ResubscribeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseResubscribeResponse();
        message.subscription = (object.subscription !== undefined && object.subscription !== null)
            ? tier_1.TierSubscription.fromPartial(object.subscription)
            : tier_1.TierSubscription.fromPartial({});
        return message;
    },
};
function createBaseCancelSubscriptionRequest() {
    return { tierType: tier_type_1.TierType.INVALID_TIER, cancellationReason: undefined };
}
exports.CancelSubscriptionRequest = {
    fromJSON(object) {
        const message = {
            tierType: isSet(object.tierType) ? (0, tier_type_1.tierTypeFromJSON)(object.tierType) : tier_type_1.TierType.INVALID_TIER,
        };
        if (isSet(object.cancellationReason)) {
            message.cancellationReason = (0, cancellation_reason_1.cancellationReasonFromJSON)(object.cancellationReason);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.tierType !== tier_type_1.TierType.INVALID_TIER) {
            obj.tierType = (0, tier_type_1.tierTypeToJSON)(message.tierType);
        }
        if (message.cancellationReason !== undefined) {
            obj.cancellationReason = (0, cancellation_reason_1.cancellationReasonToJSON)(message.cancellationReason);
        }
        return obj;
    },
    create(base) {
        return exports.CancelSubscriptionRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCancelSubscriptionRequest();
        message.tierType = object.tierType ?? tier_type_1.TierType.INVALID_TIER;
        message.cancellationReason = object.cancellationReason ?? undefined;
        return message;
    },
};
function createBaseCancelSubscriptionResponse() {
    return { subscription: tier_1.TierSubscription.fromPartial({}) };
}
exports.CancelSubscriptionResponse = {
    fromJSON(object) {
        const message = {
            subscription: isSet(object.subscription)
                ? tier_1.TierSubscription.fromJSON(object.subscription)
                : tier_1.TierSubscription.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.subscription !== undefined) {
            obj.subscription = tier_1.TierSubscription.toJSON(message.subscription);
        }
        return obj;
    },
    create(base) {
        return exports.CancelSubscriptionResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCancelSubscriptionResponse();
        message.subscription = (object.subscription !== undefined && object.subscription !== null)
            ? tier_1.TierSubscription.fromPartial(object.subscription)
            : tier_1.TierSubscription.fromPartial({});
        return message;
    },
};
function createBaseTryLookupSubscriptionRequest() {
    return {};
}
exports.TryLookupSubscriptionRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.TryLookupSubscriptionRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseTryLookupSubscriptionRequest();
        return message;
    },
};
function createBaseTryLookupSubscriptionResponse() {
    return { subscription: undefined };
}
exports.TryLookupSubscriptionResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.subscription)) {
            message.subscription = tier_1.TierSubscription.fromJSON(object.subscription);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.subscription !== undefined) {
            obj.subscription = tier_1.TierSubscription.toJSON(message.subscription);
        }
        return obj;
    },
    create(base) {
        return exports.TryLookupSubscriptionResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTryLookupSubscriptionResponse();
        message.subscription = (object.subscription !== undefined && object.subscription !== null)
            ? tier_1.TierSubscription.fromPartial(object.subscription)
            : undefined;
        return message;
    },
};
function createBaseUpdateSubscriptionPaymentRequest() {
    return { externalPaymentAccountId: '' };
}
exports.UpdateSubscriptionPaymentRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.externalPaymentAccountId)) {
            message.externalPaymentAccountId = globalThis.String(object.externalPaymentAccountId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.externalPaymentAccountId !== undefined && message.externalPaymentAccountId !== '') {
            obj.externalPaymentAccountId = message.externalPaymentAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.UpdateSubscriptionPaymentRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateSubscriptionPaymentRequest();
        message.externalPaymentAccountId = object.externalPaymentAccountId ?? '';
        return message;
    },
};
function createBaseUpdateSubscriptionPaymentResponse() {
    return { subscription: tier_1.TierSubscription.fromPartial({}) };
}
exports.UpdateSubscriptionPaymentResponse = {
    fromJSON(object) {
        const message = {
            subscription: isSet(object.subscription)
                ? tier_1.TierSubscription.fromJSON(object.subscription)
                : tier_1.TierSubscription.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.subscription !== undefined) {
            obj.subscription = tier_1.TierSubscription.toJSON(message.subscription);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateSubscriptionPaymentResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateSubscriptionPaymentResponse();
        message.subscription = (object.subscription !== undefined && object.subscription !== null)
            ? tier_1.TierSubscription.fromPartial(object.subscription)
            : tier_1.TierSubscription.fromPartial({});
        return message;
    },
};
/**
 * Tier API Service.
 */
class TierServiceClient {
    rpc;
    name = 'com.step.tier.proto.TierService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/tier';
    methods = [{
            name: 'GetUserTier',
            requestType: exports.GetUserTierRequest,
            responseType: exports.GetUserTierResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'GetTiers',
            requestType: exports.GetTiersRequest,
            responseType: exports.GetTiersResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'GetTierCatalog',
            requestType: exports.GetTierCatalogRequest,
            responseType: exports.GetTierCatalogResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'TryLookupSubscription',
            requestType: exports.TryLookupSubscriptionRequest,
            responseType: exports.TryLookupSubscriptionResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'Subscribe',
            requestType: exports.SubscribeRequest,
            responseType: exports.SubscribeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'Resubscribe',
            requestType: exports.ResubscribeRequest,
            responseType: exports.ResubscribeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'CancelSubscription',
            requestType: exports.CancelSubscriptionRequest,
            responseType: exports.CancelSubscriptionResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'UpdateSubscriptionPayment',
            requestType: exports.UpdateSubscriptionPaymentRequest,
            responseType: exports.UpdateSubscriptionPaymentResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    getUserTier(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    getTiers(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    getTierCatalog(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    tryLookupSubscription(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    subscribe(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    resubscribe(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    cancelSubscription(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    updateSubscriptionPayment(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.TierServiceClient = TierServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tier-service.js.map